<template>
  <div class="basic-info-contanier">
    <b-row>
      <b-col md="7">
        <b-row>
          <b-col md="12">
            <b-form-group
              :label="field_name + ' name'"
              label-for="event_name"
              :class_name="event_name"
              :label-class="{
                'form-label-doomyoga': client_name == 'DY',
                'form-label-mid': client_name == 'MID',
              }"
            >
              <b-form-input
                id="event_name"
                v-bind:class="{
                  'form-control-doomyoga': client_name == 'DY',
                  'form-control-mid': client_name == 'MID',
                }"
                v-model="_event_name"
                :event_name="event_name"
                required
              ></b-form-input>
            </b-form-group> </b-col
          ><b-col md="12">
            <b-form-group
              :label="field_name + ' description (optional)'"
              label-for="event_description"
              :event_description="event_description"
              :label-class="{
                'form-label-doomyoga': client_name == 'DY',
                'form-label-mid': client_name == 'MID',
              }"
            >
              <b-form-textarea
                id="event_description"
                v-bind:class="{
                  'form-control-doomyoga': client_name == 'DY',
                  'form-control-mid': client_name == 'MID',
                }"
                v-model="_event_description"
                :event_description="event_description"
                rows="3"
              ></b-form-textarea>
            </b-form-group> </b-col
        ></b-row>
      </b-col>
      <b-col md="5">
        <b-form-group
          label="Cover image (optional)"
          label-for="cover_image"
          :cover_image="cover_image"
          class="imgFromGroup h-100"
          :label-class="{
            'form-label-doomyoga': client_name == 'DY',
            'form-label-mid': client_name == 'MID',
          }"
        >
          <input
            type="file"
            class="file-upload inputFileHidden d-none"
            name="cover_image"
            id="cover_image"
            accept="image/*"
            @change="previewImage"
          />

          <div
            class="previewImageDiv h-100"
            :class="{
              previewImageDYDiv: client_name == 'DY',
              previewImageMIDDiv: client_name == 'MID',
            }"
            @click="addFile('cover_image')"
            v-bind:style="{ 'background-image': 'url(' + preview + ')' }"
          >
            <p v-show="preview == null" class="uploadFileP text-center">
              Click here to upload your image
            </p>
          </div>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="7">
        <b-row>
          <b-col md="6">
            <b-form-group
              class="form-group-check"
              :class="{
                'form-group-check-doomyoga': client_name == 'DY',
                'form-group-check-mid': client_name == 'MID',
              }"
              :label="'Is this ' + field_name + ' in person?'"
              v-slot="{ ariaDescribedby }"
            >
              <div class="row">
                <div class="col">
                  <div class="form-check form-check-radio">
                    <label class="form-check-label">
                      <input
                        class="form-check-input"
                        type="radio"
                        id="isEventInPerson1"
                        name="is_event_in_person"
                        v-model="_is_event_in_person"
                        value="1"
                        :aria-describedby="ariaDescribedby"
                        required
                      />
                      Yes
                      <span class="circle">
                        <span class="check"></span>
                      </span>
                    </label>
                  </div>
                </div>
                <div class="col">
                  <div class="form-check form-check-radio">
                    <label class="form-check-label">
                      <input
                        class="form-check-input"
                        type="radio"
                        id="isEventInPerson0"
                        name="is_event_in_person"
                        v-model="_is_event_in_person"
                        value="0"
                        :aria-describedby="ariaDescribedby"
                        required
                      />
                      No
                      <span class="circle">
                        <span class="check"></span>
                      </span>
                    </label>
                  </div>
                </div>
              </div> </b-form-group
          ></b-col>
          <!-- end is event in person -->
          <b-col md="6">
            <b-form-group
              class="form-group-check"
              :class="{
                'form-group-check-doomyoga': client_name == 'DY',
                'form-group-check-mid': client_name == 'MID',
              }"
              :label="'Is this ' + field_name + ' recurring?'"
              v-slot="{ ariaDescribedby }"
            >
              <div class="row">
                <div class="col">
                  <div class="form-check form-check-radio">
                    <label class="form-check-label">
                      <input
                        class="form-check-input"
                        type="radio"
                        id="isEventReccuring1"
                        name="is_cevent_recurring"
                        v-model="_is_event_recurring"
                        value="1" required
                        :aria-describedby="ariaDescribedby"
                        @click="clickIsRecuring(1)"
                      />
                      Yes
                      <span class="circle">
                        <span class="check"></span>
                      </span>
                    </label>
                  </div>
                </div>
                <div class="col">
                  <div class="form-check form-check-radio">
                    <label class="form-check-label">
                      <input
                        class="form-check-input"
                        type="radio"
                        id="isEventReccuring0"
                        name="is_cevent_recurring"
                        v-model="_is_event_recurring"
                        value="0" required
                        :aria-describedby="ariaDescribedby"
                        @click="clickIsRecuring(0)"
                      />
                      No
                      <span class="circle">
                        <span class="check"></span>
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </b-form-group> </b-col
          ><!-- end is event recurring -->
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>


<script>
import $, { event } from "jquery";

export default {
  name: "EventBasicData",
  props: [
    "client_name","field_name",
    "event_name",
    "event_description",
    "is_event_in_person",
    "is_event_recurring",
    "cover_image",
    "preview",
    "cover_image_id",
  ],

  components: {},
  data() {
    return {};
  },
  mounted() {},
  computed: {
    _event_name: {
      get() {
        return this.event_name;
      },
      set(value) {
        // console.log(value);
        this.$emit("update:event_name", value);
      },
    },
    _event_description: {
      get() {
        return this.event_description;
      },
      set(value) {
        this.$emit("update:event_description", value);
      },
    },
    _is_event_in_person: {
      get() {
        return this.is_event_in_person;
      },
      set(value) {
        console.log(value);
        this.$emit("update:is_event_in_person", value);
      },
    },
    _is_event_recurring: {
      get() {
        return this.is_event_recurring;
      },
      set(value) {
        console.log(value);
        this.$emit("update:is_event_recurring", value);
      },
    },

    _preview: {
      get() {
        return this.preview;
      },
      set(value) {
        console.log(value);
        this.$emit("update:preview", value);
      },
    },
    _cover_image: {
      get() {
        return this.cover_image;
      },
      set(value) {
        this.$emit("update:cover_image", value);
      },
    },
    _cover_image_id: {
      get() {
        return this.cover_image_id;
      },
      set(value) {
        console.log(value);
        this.$emit("update:cover_image_id", value);
      },
    },
  },
  methods: {
    clickIsRecuring(val){
      this.$parent.clickIsRecuring(val)
    },
     previewImage: function (e) {
      console.log(this.cover_image);
      var input = e.target;
      if (input.files) {
        var reader = new FileReader();
        reader.readAsDataURL(input.files[0]);
        reader.onload = (e) => {
        //   this.preview = e.target.result;        
        this.$emit("update:preview", e.target.result);

        };
        console.log(e.target.files[0])
        // this.cover_image = e.target.files[0];
        this.$emit("update:cover_image", e.target.files[0]);
        
        console.log(this.cover_image);
        console.log(this._cover_image);
      }
    },
    addFile(id) {
      console.log("click file " + id);
      $("#" + id).click();
    },
  },
};
</script>
<style >
</style>


// WEBPACK FOOTER //
// src/components/events/BasicData.vue